import { styled } from "@mui/material/styles";

const Div = styled('div')({});

export default Div;